module.exports = {
  viewOnly: false,
  onlyViewEmployee: [],
  timeClock: {
    inOut: true,
    delete: true,
    create: true,
    edit: true,
    instant: false,
    instantReport: true
  },
  pay: {
    create: true,
    delete: true,
    markUnPickup: true,
    pickup: true
  },
  employee: {
    list: true,
    createAdmin: true,
    create: true,
    edit: true,
    delete: true,
    viewProfile: true
  },
  report: {
    view: true,
    showPay: true,
    showHours: true,
    showSignature: true
  },
  setting: {
    edit: true,
    switchLocation: true,
    account: true,
  }
}